import Link from "@/components/Link";
import { cn } from "@/lib/utils";
import SvgFacebook from "@/styles/icons/Facebook";
import SvgHamburger from "@/styles/icons/Hamburger";
import SvgInstagram from "@/styles/icons/Instagram";
import SvgTikTok from "@/styles/icons/TikTok";
import SvgYoutube from "@/styles/icons/Youtube";
import Image from "next/image";
import { useEffect, useState } from "react";
import { NavigationMenu } from "./NaviagtionMenu";

export const Navbar: React.FC = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [logoWidth, setLogoWidth] = useState(225);
  const [navbarHeight, setNavbarHeight] = useState(110);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setLogoWidth(125);
        setNavbarHeight(64);
      } else {
        setLogoWidth(225);
        setNavbarHeight(110);
      }
      setShowMenu(false);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
		<nav className='sticky top-0 z-50'>
			<div
				className='justify-between flex items-center bg-accent-color-three-dark py-4 px-6 desktop:px-32'
				style={{
					height: navbarHeight,
					transition: 'height 0.3s cubic-bezier(0.4,0,0.2,1)',
				}}
			>
				<a href='/'>
					<img
						src='/Logo-light.svg'
						alt='Solomon Plastic Surgery'
						style={{
							width: logoWidth,
							transition: 'width 0.3s cubic-bezier(0.4,0,0.2,1)',
							display: 'block',
						}}
					/>
				</a>
				<div className='flex gap-6 md:gap-9 max-md:ml-6'>
					<ul className='flex gap-4 max-desktop:hidden items-end'>
						<li>
							<a
								href='https://www.facebook.com/solomonplasticsurgery/solomonplasticsurgery/'
								className={cn(
									'hover:text-yellow-400 transition-colors',
									'text-gray-400',
									'desktop:text-white desktop:hover:text-gray-400'
								)}
							>
								<SvgFacebook className={cn('w-5 h-5', 'md:w-6 md:h-6')} />
							</a>
						</li>
						<li>
							<a
								href='https://www.instagram.com/solomonplasticsurgery/'
								className={cn(
									'hover:text-yellow-400 transition-colors',
									'text-gray-400',
									'desktop:text-white desktop:hover:text-gray-400'
								)}
							>
								<SvgInstagram className={cn('w-5 h-5', 'md:w-6 md:h-6')} />
							</a>
						</li>
						<li>
							<a
								href='https://www.tiktok.com/@solomonplasticsurgery'
								className={cn(
									'hover:text-yellow-400 transition-colors',
									'text-gray-400',
									'desktop:text-white desktop:hover:text-gray-400'
								)}
							>
								<SvgTikTok className={cn('w-5 h-5', 'md:w-6 md:h-6')} />
							</a>
						</li>
						<li>
							<a
								href='https://www.youtube.com/channel/UC_1kmCifgvaWtu0fGMuwcSg'
								className={cn(
									'hover:text-yellow-400 transition-colors',
									'text-gray-400',
									'desktop:text-white desktop:hover:text-gray-400'
								)}
							>
								<SvgYoutube className={cn('w-5 h-5', 'md:w-6 md:h-6')} />
							</a>
						</li>
					</ul>
					<a
						href={'tel:' + '214.234.0277'}
						className={cn('text-span-medium underline text-white')}
					>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							width='25'
							height='26'
							viewBox='0 0 25 26'
							fill='none'
							className='md:hidden'
						>
							<circle
								cx='12.5'
								cy='13'
								r='11.75'
								stroke='#D3BFA4'
								stroke-width='1.5'
							/>
							<path
								d='M16.5634 13.0404C16.4999 12.9768 16.4245 12.9264 16.3416 12.892C16.2586 12.8576 16.1696 12.8399 16.0798 12.8399C15.99 12.8399 15.901 12.8576 15.818 12.892C15.735 12.9264 15.6597 12.9768 15.5962 13.0404L14.5059 14.1307C14.0004 13.9802 13.0571 13.6382 12.4593 13.0404C11.8615 12.4426 11.5195 11.4994 11.369 10.9939L12.4593 9.90365C12.5229 9.84019 12.5733 9.76481 12.6077 9.68183C12.6421 9.59885 12.6598 9.5099 12.6598 9.42007C12.6598 9.33024 12.6421 9.24129 12.6077 9.15832C12.5733 9.07534 12.5229 8.99996 12.4593 8.9365L9.72323 6.20055C9.65976 6.13697 9.58438 6.08654 9.5014 6.05212C9.41842 6.01771 9.32946 6 9.23963 6C9.1498 6 9.06084 6.01771 8.97786 6.05212C8.89488 6.08654 8.8195 6.13697 8.75603 6.20055L6.90098 8.05552C6.64106 8.31543 6.49468 8.67248 6.50015 9.03704C6.51588 10.011 6.77375 13.394 9.44005 16.0602C12.1063 18.7264 15.4895 18.9836 16.4642 19H16.4834C16.8445 19 17.1858 18.8577 17.4444 18.5992L19.2994 16.7442C19.363 16.6807 19.4135 16.6054 19.4479 16.5224C19.4823 16.4394 19.5 16.3505 19.5 16.2606C19.5 16.1708 19.4823 16.0819 19.4479 15.9989C19.4135 15.9159 19.363 15.8405 19.2994 15.7771L16.5634 13.0404ZM16.4765 17.6313C15.6229 17.617 12.7021 17.3878 10.4072 15.0924C8.10485 12.7901 7.88186 9.85919 7.86818 9.02268L9.23963 7.65128L11.0085 9.42007L10.1241 10.3045C10.0437 10.3848 9.98455 10.4839 9.95207 10.5928C9.91958 10.7017 9.91475 10.817 9.93801 10.9283C9.95443 11.0069 10.3559 12.8722 11.4914 14.0076C12.6269 15.143 14.4922 15.5445 14.5708 15.5609C14.682 15.5848 14.7974 15.5804 14.9065 15.548C15.0155 15.5156 15.1146 15.4563 15.1947 15.3756L16.0798 14.4912L17.8486 16.2599L16.4765 17.6313Z'
								fill='#F6DFBF'
							/>
						</svg>
						<span className='max-md:hidden'>214-234-0277</span>
					</a>
					<button
						className='bg-none text-[#fff] self-end hover:opacity-70 transition-all'
						onClick={() => setShowMenu(!showMenu)}
					>
						<span className='sr-only'>Navigation menu</span>
						<SvgHamburger height={24} width={24} />
					</button>
				</div>
			</div>
			<div
				data-shown={showMenu}
				className={cn(
					'group grid grid-rows-[0fr] transition-[grid-template-rows] duration-500 absolute top-full left-0 w-full max-h-svh',
					showMenu && 'grid-rows-[1fr]'
				)}
			>
				<NavigationMenu />
			</div>
		</nav>
	)
};
